import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, $dmSansFontFamily, setFontVariant } from '@similarweb/styles';

import { ActionButton } from '../../../components/ActionButton';
import { Dropdown } from '../../../components/Dropdown';
import { StyledDropdownOption } from '../../../components/Dropdown/styles';

export const StyledMultipleDomainsContainer = styled.div<{ isOneCompany: boolean }>`
  margin: 17px 24px 5px;
  padding: ${({ isOneCompany }) => (isOneCompany ? '24px 16px 11px 16px' : '24px 16px 16px 16px')};
  border-radius: 8px;
  border: 0.5px solid ${colorsPalettes.blue[500]};
  box-shadow: 0px 4px 13px 0px rgba(173, 173, 173, 0.25);
`;

export const StyledMeetingTitle = styled.div`
  font-family: ${$dmSansFontFamily};
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  color: ${colorsPalettes.carbon[500]};
  margin-bottom: 8px;
`;

export const StyledMeetingDate = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-family: ${$dmSansFontFamily};
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${colorsPalettes.carbon[300]};
  margin-bottom: 12px;
`;

export const StyledMeetingDateSeparator = styled.div`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background-color: ${colorsPalettes.carbon[300]};
  margin: 0px 10px;
  flex: none;
`;

export const StyledMeetingInternalText = styled.div`
  margin-bottom: 5px;
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[400])};
  font-weight: 500;
`;

export const StyledMultipleDomainsButtonText = styled.div<{ isSingleDomain?: boolean }>`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[300])};
  font-size: ${({ isSingleDomain }) => (isSingleDomain ? '14px' : '12px')};
  margin-right: 8px;
`;

export const StyledExternalMultipleDomainsContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const StyledActionButton = styled(ActionButton)<{ width: number }>`
  flex: 1;
  justify-content: center;
  width: ${({ width }) => `${width}px`};
`;

export const StyledMultipleDomainsDropdown = styled(Dropdown)`
  overflow: visible;
  padding: 8px 0;
`;

export const StyledMultipleDomainsDropdownOption = styled(StyledDropdownOption)`
  padding: 10px 12px;
`;

export const StyledCompanyLogo = styled.div<{ isSmall?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ isSmall }) => (isSmall ? '16px' : '24px')};
  height: ${({ isSmall }) => (isSmall ? '16px' : '24px')};
  min-width: ${({ isSmall }) => (isSmall ? '16px' : '24px')};
  min-height: ${({ isSmall }) => (isSmall ? '16px' : '24px')};
  margin-right: 8px;
  background-color: ${colorsPalettes.carbon[0]};
  border: solid rgba(214, 219, 225, 1);
  border-width: ${({ isSmall }) => (isSmall ? '0.75px' : '0.5px')};
  border-radius: ${({ isSmall }) => (isSmall ? '3px' : '4.5px')};
`;

export const StyledEmailDomainContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-bottom: 13px;
`;

export const StyledEmailSubject = styled.p`
  ${setFontVariant('subsectionTitle')};
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 0;
`;

export const StyledEmailDomain = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  margin-left: 8px;
`;

export const StyledCorrespondenceWithText = styled.div`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[500])};
  font-weight: 500;
`;

export const StyledDropdownButtonIcon = styled(SWReactIcons)`
  min-width: 16px;
`;
